// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .footer--mrKkl {
  background-color: white;
}

[dir] .footerWrapperEmbed--OGx1f {
  background-color: white;
  border-top: 1px solid #d8d8d8;
}

[dir=ltr] .separator--QqtRi {
  margin-left: 5px;
  margin-right: 5px;
}

[dir=rtl] .separator--QqtRi {
  margin-right: 5px;
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/Footer/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAHA;EACE,iBAAgB;EAChB,gBAAiB;AACnB","sourcesContent":[".footer {\n  background-color: white;\n}\n\n.footerWrapperEmbed {\n  background-color: white;\n  border-top: 1px solid #d8d8d8;\n}\n\n.separator {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer--mrKkl`,
	"footerWrapperEmbed": `footerWrapperEmbed--OGx1f`,
	"separator": `separator--QqtRi`
};
export default ___CSS_LOADER_EXPORT___;
